import styled from 'styled-components';

export const AgentListingsWrapper = styled.div`
  margin-top: 0px;
`;

export const AgentCarouselWrapper = styled.div`
  position: relative;

  &:hover .carousel-arrow {
    opacity: 1;
  }

  /* Mobile/tablet: hide arrows entirely when 1 or fewer listings */
  @media (max-width: 1024px) {
    &[data-show-arrows-mobile='false'] .carousel-arrow {
      display: none;
    }
  }

  /* Desktop: hide arrows entirely when 3 or fewer listings */
  @media (min-width: 1025px) {
    &[data-show-arrows-desktop='false'] .carousel-arrow {
      display: none;
    }
  }
`;

export const AgentCarouselTrack = styled.div`
  display: flex;
  gap: 12px;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  scrollbar-width: none;
  padding-bottom: 4px;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const AgentCardLink = styled.a`
  display: flex;
  flex-direction: column;
  width: 200px;
  flex-shrink: 0;
  scroll-snap-align: start;
  border-radius: 16px;
  overflow: hidden;
  border: 1px solid #f5f5f5;
  background: #ffffff;
  text-decoration: none;
  color: inherit;
  transition: box-shadow 0.15s ease;
  box-shadow: 0 2px 4px rgba(40, 44, 46, 0.08);
  z-index: 1;
  position: relative;

  &:hover {
    box-shadow: 0 2px 4px rgba(40, 44, 46, 0.18);
    text-decoration: none;
    color: inherit;
  }

  @media (max-width: 576px) {
    width: 220px;
  }
`;

export const CardImageWrapper = styled.div`
  position: relative;
  width: 100%;
  padding-top: 65%;
  overflow: hidden;
  background: #f0f0f0;

  @media (max-width: 576px) {
    padding-top: 75%;
  }
`;

export const CardImage = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: auto;
  object-fit: cover;
  aspect-ratio: 1.33333;
`;

export const CardBody = styled.div`
  padding: 10px 12px 12px;
  display: flex;
  flex-direction: column;
  gap: 5px;
  flex: 1;
`;

export const CardTitle = styled.h4`
  font-size: 14px;
  font-weight: 500;
  color: #0d1011;
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const CardSubtitle = styled.p`
  font-size: 14px;
  color: #0d1011;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 300;
`;

export const CardPrice = styled.p`
  font-size: 15px;
  font-weight: 500;
  color: #212529;
  margin: 0;
`;

export const CardRooms = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 4px;
`;

export const CardRoomItem = styled.span`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 14px;
  color: #0d1011;
  font-weight: 300;
`;

export const CardBadge = styled.span`
  display: inline-flex;
  align-self: flex-start;
  padding: 4px 8px;
  border-radius: 8px;
  border: 1px solid #c1c9d2;
  font-size: 12px;
  color: #5a6067;
  margin-top: 2px;
  font-weight: 400;
`;

export const ContactAgentButton = styled.span`
  display: inline-block;
  padding: 5px 12px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  text-decoration: none;
  display: flex;
  box-shadow:
    0px 2px 2px 0px #fff6 inset,
    0px 2px 4px 0px #282c2e1f;
  background-color: #cc0000;
  color: #ffffff;
  font-size: 12px;
  font-weight: 500;
  border-radius: 100px;
  text-decoration: none;
  cursor: pointer;
  margin-top: 8px;

  .item-icon {
    display: inline-block;
    width: 28px;
    margin-right: -28px;
    font-size: 28px;
    text-align: center;
    vertical-align: middle;
    color: #ffffff;
  }

  &:hover {
    background-color: #aa0000;
    color: #ffffff;
    text-decoration: none;
  }
`;

export const CarouselArrow = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #ffffff;
  border: 1px solid #e0e0e0;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.12);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  opacity: 0;
  transition:
    opacity 0.2s ease,
    background 0.15s ease;

  &:hover {
    background: #f5f5f5;
  }

  &.prev {
    left: 8px;
  }
  &.next {
    right: 8px;
  }

  /* Always visible on touch devices */
  @media (max-width: 1024px) {
    opacity: 1;
    top: 40%;
  }
`;

export const CardLastUpdated = styled.p`
  font-size: 8px;
  color: #777777;
  margin: 8px 0 0 0;
  font-weight: 300;
  text-align: right;
`;
